import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

/** Dominio definitivo de FMG3D, usado para la imagen al compartir y los datos estructurados. */
export const productionUrl = 'https://fmg3d.cl'

export const siteConfig: SiteConfig = {
    name: 'FMG3D',
    description: 'Objetos a medida diseñados y fabricados en familia en San Esteban, Los Andes. Macetas, lámparas, piezas de temporada, ruletas para fonoaudiología y pedidos especiales en el Valle del Aconcagua.',
    url: getOrigin(),
    ogImage: `${productionUrl}/api/og`
}
